import { render } from "./updateLicense.vue?vue&type=template&id=02999c60"
const script = {}

import exportComponent from "/home/forge/pa.aneto-apps.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__